import(/* webpackMode: "eager" */ "/vercel/path0/src/app/marketplace/[id]/page.tsx");
